export default __webpack_public_path__ + "static/media/banner2.459b7300.jpg";